// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sessionview-slide-menu-hoverarea {
  position: absolute;
  pointer-events: auto;
  background-color: transparent;
  --panel-offset: calc(var(--overlay-panel-padding) * 3);
  --hoverarea-width: calc(var(--overlay-panel-padding) * 2);
  padding: var(--hoverarea-width);
  z-index: 1;
}

.sessionview-slide-menu-hoverarea.sessionview-slide-menu-position-topleft,
.sessionview-slide-menu-hoverarea.sessionview-slide-menu-position-topright {
  padding-top: 0;
}

.sessionview-slide-menu {
  background-color: var(--overlay-panel-background-color);
  color: var(--text-contrast-color);
  padding: calc(var(--overlay-panel-padding) / 2);
  box-shadow: 0px 0px 7px 0px rgba(255, 255, 255, 0.67);
  position: relative;

  > h2 {
    margin: 0 0 var(--overlay-panel-padding) 0;
    text-align: center;
  }

  opacity: 0;
  transition: opacity 0.5s ease-out;
}

.sessionview-slide-menu-content {
  display: flex;
  flex-direction: row;
  gap: var(--overlay-panel-element-gap);
  align-items: center;
}

.sessionview-slide-menu-content button {
  color: var(--text-contrast-color);
}

.sessionview-slide-menu-position-bottom {
  bottom: 0;
  left: 50%;
  transform: translate(-50%, calc(100% - var(--panel-offset)));
  transition: transform 0.5s ease-out;

  > .sessionview-slide-menu {
    padding-top: var(--overlay-panel-padding);
    padding-left: var(--overlay-panel-padding);
    padding-right: var(--overlay-panel-padding);
    border-top-left-radius: var(--overlay-panel-border-radius);
    border-top-right-radius: var(--overlay-panel-border-radius);
  }

  &:hover,
  &.sessionview-slide-menu-pinned {
    transform: translate(-50%, var(--hoverarea-width));
  }
}

.sessionview-slide-menu-position-topleft {
  left: 0;
  transform: translateX(calc(var(--panel-offset) - 100%));
  transition: transform 0.5s ease-out;

  > .sessionview-slide-menu {
    padding-right: var(--overlay-panel-padding);
    border-bottom-right-radius: var(--overlay-panel-border-radius);
  }

  &:hover,
  &.sessionview-slide-menu-pinned {
    transform: translateX(calc(var(--hoverarea-width) * -1));
  }
}

.sessionview-slide-menu-position-topright {
  right: 0;
  transform: translateX(calc(100% - var(--panel-offset)));
  transition: transform 0.5s ease-out;

  > .sessionview-slide-menu {
    padding-left: var(--overlay-panel-padding);
    border-bottom-left-radius: var(--overlay-panel-border-radius);
  }

  &:hover,
  &.sessionview-slide-menu-pinned {
    transform: translateX(var(--hoverarea-width));
  }
}

.sessionview-slide-menu-position-topleft,
.sessionview-slide-menu-position-topright {
  top: 0;
}

.sessionview-slide-menu-position-topleft > .sessionview-slide-menu,
.sessionview-slide-menu-position-bottom > .sessionview-slide-menu {
  padding-right: calc(var(--overlay-panel-padding) * 2) !important;
}

.sessionview-slide-menu-position-topright > .sessionview-slide-menu {
  padding-left: calc(var(--overlay-panel-padding) * 2) !important;
}

.sessionview-slide-menu-pinbutton {
  transform: rotate(-45deg);
  transition: transform 0.25s ease-out;
}

.sessionview-slide-menu-position-topright .sessionview-slide-menu-pinbutton {
  transform: rotate(45deg);
  left: unset;
}

.sessionview-slide-menu-position-bottom .sessionview-slide-menu-pinbutton {
  transform: rotate(225deg);
}

.sessionview-slide-menu-pinned .sessionview-slide-menu-pinbutton-container {
  opacity: 1 !important;
}

.sessionview-slide-menu-pinned .sessionview-slide-menu-pinbutton {
  transform: rotate(45deg);
}

.sessionview-slide-menu-position-topright.sessionview-slide-menu-pinned
  .sessionview-slide-menu-pinbutton {
  transform: rotate(-45deg);
}

.sessionview-slide-menu-position-bottom.sessionview-slide-menu-pinned
  .sessionview-slide-menu-pinbutton {
  transform: rotate(135deg);
}

.sessionview-slide-menu-hoverarea:hover
  .sessionview-slide-menu-pinbutton-container {
  opacity: 0.5;
}

.sessionview-slide-menu-pinbutton-container {
  background-color: var(--dark-grey-transparent);
  border-top: 1px solid var(--border-color-transparent);
  border-left: 1px solid var(--border-color-transparent);
  border-top-left-radius: var(--overlay-panel-border-radius);
  border-bottom-right-radius: var(--overlay-panel-border-radius);
  padding: calc(var(--overlay-panel-border-radius) / 2);
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.5s ease-out;
}

.sessionview-slide-menu-position-topright
  .sessionview-slide-menu-pinbutton-container {
  right: unset;
  left: 0;
  border-left: unset;
  border-right: 1px solid var(--border-color-transparent);
  border-top-left-radius: unset;
  border-top-right-radius: var(--overlay-panel-border-radius);
  border-bottom-right-radius: unset;
  border-bottom-left-radius: var(--overlay-panel-border-radius);
}

.sessionview-slide-menu-position-bottom
  .sessionview-slide-menu-pinbutton-container {
  bottom: unset;
  top: 0;
  border-top: unset;
  border-bottom: 1px solid var(--border-color-transparent);
  border-top-left-radius: unset;
  border-bottom-left-radius: var(--overlay-panel-border-radius);
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/session-view-slide-menu/SessionViewSlideMenu.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,sDAAsD;EACtD,yDAAyD;EACzD,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uDAAuD;EACvD,iCAAiC;EACjC,+CAA+C;EAC/C,qDAAqD;EACrD,kBAAkB;;EAElB;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,SAAS;EACT,4DAA4D;EAC5D,mCAAmC;;EAEnC;IACE,yCAAyC;IACzC,0CAA0C;IAC1C,2CAA2C;IAC3C,0DAA0D;IAC1D,2DAA2D;EAC7D;;EAEA;;IAEE,kDAAkD;EACpD;AACF;;AAEA;EACE,OAAO;EACP,uDAAuD;EACvD,mCAAmC;;EAEnC;IACE,2CAA2C;IAC3C,8DAA8D;EAChE;;EAEA;;IAEE,wDAAwD;EAC1D;AACF;;AAEA;EACE,QAAQ;EACR,uDAAuD;EACvD,mCAAmC;;EAEnC;IACE,0CAA0C;IAC1C,6DAA6D;EAC/D;;EAEA;;IAEE,6CAA6C;EAC/C;AACF;;AAEA;;EAEE,MAAM;AACR;;AAEA;;EAEE,gEAAgE;AAClE;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,qDAAqD;EACrD,sDAAsD;EACtD,0DAA0D;EAC1D,8DAA8D;EAC9D,qDAAqD;EACrD,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,iCAAiC;AACnC;;AAEA;;EAEE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,uDAAuD;EACvD,6BAA6B;EAC7B,2DAA2D;EAC3D,iCAAiC;EACjC,6DAA6D;AAC/D;;AAEA;;EAEE,aAAa;EACb,MAAM;EACN,iBAAiB;EACjB,wDAAwD;EACxD,6BAA6B;EAC7B,6DAA6D;AAC/D","sourcesContent":[".sessionview-slide-menu-hoverarea {\n  position: absolute;\n  pointer-events: auto;\n  background-color: transparent;\n  --panel-offset: calc(var(--overlay-panel-padding) * 3);\n  --hoverarea-width: calc(var(--overlay-panel-padding) * 2);\n  padding: var(--hoverarea-width);\n  z-index: 1;\n}\n\n.sessionview-slide-menu-hoverarea.sessionview-slide-menu-position-topleft,\n.sessionview-slide-menu-hoverarea.sessionview-slide-menu-position-topright {\n  padding-top: 0;\n}\n\n.sessionview-slide-menu {\n  background-color: var(--overlay-panel-background-color);\n  color: var(--text-contrast-color);\n  padding: calc(var(--overlay-panel-padding) / 2);\n  box-shadow: 0px 0px 7px 0px rgba(255, 255, 255, 0.67);\n  position: relative;\n\n  > h2 {\n    margin: 0 0 var(--overlay-panel-padding) 0;\n    text-align: center;\n  }\n\n  opacity: 0;\n  transition: opacity 0.5s ease-out;\n}\n\n.sessionview-slide-menu-content {\n  display: flex;\n  flex-direction: row;\n  gap: var(--overlay-panel-element-gap);\n  align-items: center;\n}\n\n.sessionview-slide-menu-content button {\n  color: var(--text-contrast-color);\n}\n\n.sessionview-slide-menu-position-bottom {\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%, calc(100% - var(--panel-offset)));\n  transition: transform 0.5s ease-out;\n\n  > .sessionview-slide-menu {\n    padding-top: var(--overlay-panel-padding);\n    padding-left: var(--overlay-panel-padding);\n    padding-right: var(--overlay-panel-padding);\n    border-top-left-radius: var(--overlay-panel-border-radius);\n    border-top-right-radius: var(--overlay-panel-border-radius);\n  }\n\n  &:hover,\n  &.sessionview-slide-menu-pinned {\n    transform: translate(-50%, var(--hoverarea-width));\n  }\n}\n\n.sessionview-slide-menu-position-topleft {\n  left: 0;\n  transform: translateX(calc(var(--panel-offset) - 100%));\n  transition: transform 0.5s ease-out;\n\n  > .sessionview-slide-menu {\n    padding-right: var(--overlay-panel-padding);\n    border-bottom-right-radius: var(--overlay-panel-border-radius);\n  }\n\n  &:hover,\n  &.sessionview-slide-menu-pinned {\n    transform: translateX(calc(var(--hoverarea-width) * -1));\n  }\n}\n\n.sessionview-slide-menu-position-topright {\n  right: 0;\n  transform: translateX(calc(100% - var(--panel-offset)));\n  transition: transform 0.5s ease-out;\n\n  > .sessionview-slide-menu {\n    padding-left: var(--overlay-panel-padding);\n    border-bottom-left-radius: var(--overlay-panel-border-radius);\n  }\n\n  &:hover,\n  &.sessionview-slide-menu-pinned {\n    transform: translateX(var(--hoverarea-width));\n  }\n}\n\n.sessionview-slide-menu-position-topleft,\n.sessionview-slide-menu-position-topright {\n  top: 0;\n}\n\n.sessionview-slide-menu-position-topleft > .sessionview-slide-menu,\n.sessionview-slide-menu-position-bottom > .sessionview-slide-menu {\n  padding-right: calc(var(--overlay-panel-padding) * 2) !important;\n}\n\n.sessionview-slide-menu-position-topright > .sessionview-slide-menu {\n  padding-left: calc(var(--overlay-panel-padding) * 2) !important;\n}\n\n.sessionview-slide-menu-pinbutton {\n  transform: rotate(-45deg);\n  transition: transform 0.25s ease-out;\n}\n\n.sessionview-slide-menu-position-topright .sessionview-slide-menu-pinbutton {\n  transform: rotate(45deg);\n  left: unset;\n}\n\n.sessionview-slide-menu-position-bottom .sessionview-slide-menu-pinbutton {\n  transform: rotate(225deg);\n}\n\n.sessionview-slide-menu-pinned .sessionview-slide-menu-pinbutton-container {\n  opacity: 1 !important;\n}\n\n.sessionview-slide-menu-pinned .sessionview-slide-menu-pinbutton {\n  transform: rotate(45deg);\n}\n\n.sessionview-slide-menu-position-topright.sessionview-slide-menu-pinned\n  .sessionview-slide-menu-pinbutton {\n  transform: rotate(-45deg);\n}\n\n.sessionview-slide-menu-position-bottom.sessionview-slide-menu-pinned\n  .sessionview-slide-menu-pinbutton {\n  transform: rotate(135deg);\n}\n\n.sessionview-slide-menu-hoverarea:hover\n  .sessionview-slide-menu-pinbutton-container {\n  opacity: 0.5;\n}\n\n.sessionview-slide-menu-pinbutton-container {\n  background-color: var(--dark-grey-transparent);\n  border-top: 1px solid var(--border-color-transparent);\n  border-left: 1px solid var(--border-color-transparent);\n  border-top-left-radius: var(--overlay-panel-border-radius);\n  border-bottom-right-radius: var(--overlay-panel-border-radius);\n  padding: calc(var(--overlay-panel-border-radius) / 2);\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 0.5s ease-out;\n}\n\n.sessionview-slide-menu-position-topright\n  .sessionview-slide-menu-pinbutton-container {\n  right: unset;\n  left: 0;\n  border-left: unset;\n  border-right: 1px solid var(--border-color-transparent);\n  border-top-left-radius: unset;\n  border-top-right-radius: var(--overlay-panel-border-radius);\n  border-bottom-right-radius: unset;\n  border-bottom-left-radius: var(--overlay-panel-border-radius);\n}\n\n.sessionview-slide-menu-position-bottom\n  .sessionview-slide-menu-pinbutton-container {\n  bottom: unset;\n  top: 0;\n  border-top: unset;\n  border-bottom: 1px solid var(--border-color-transparent);\n  border-top-left-radius: unset;\n  border-bottom-left-radius: var(--overlay-panel-border-radius);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
